<template>
    <div class="card center">
        <Sidebar v-model:visible="visible" position="right">
            <template #container="{ closeCallback }">
                <div class="sidebar-container">
                    <div class="header">
                        <span class="branding">
                            <img class="logo" src="/images/blasio_logo2.svg" alt="Blasio design tervező iroda logója"
                                @click="topPage()">
                        </span>
                        <Button icon="pi pi-times" @click="closeCallback" class="close-button" />
                    </div>


                    <div class="menu-content">
                        <ul class="menu-list">
                            
                            <li class="menu-section">
                                <router-link to="/" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
                                    $t('header.routes.home') }}</router-link>
                            </li>

                            <li class="menu-section">
                                <router-link to="/about" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
                                    $t('header.routes.about') }}</router-link>
                            </li>
                            
                            <li class="menu-section">
                                <router-link to="/portfolio" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
                                    $t('header.routes.portfolio') }}</router-link>
                            </li>

                            <li class="menu-section">
                                <router-link to="/team" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
                                    $t('header.routes.team') }}</router-link>
                            </li>
                            
                            <li class="menu-section">
                                <router-link to="/contact" :class="props.onHomePage ? 'color-light' : 'color-dark'">{{
                                    $t('header.routes.contact') }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="footer">
                    <div class="header-icons">
                        <a href="https://epiteszforum.hu/" target="_blank">
                            <img class="header-icon" :class="props.onHomePage ? 'fill-light' : 'fill-dark'"
                                src="/images/icons/epforum.svg" alt="Blasio design építészfórum oldala" />
                        </a>
                        <a href="https://www.instagram.com/" target="_blank">
                            <img class="header-icon" :class="props.onHomePage ? 'fill-light' : 'fill-dark'"
                                src="/images/icons/instagram.svg" alt="Blasio design instagram oldala" />
                        </a>
                        <a href="https://www.facebook.com/" target="_blank">
                            <img class="header-icon" :class="props.onHomePage ? 'fill-light' : 'fill-dark'"
                                src="/images/icons/facebook.svg" alt="Blasio design facebook oldala" />
                        </a>
                        <h6 class="lang" @click="setLang('hu')">HU</h6>
                        <h6 class="lang" @click="setLang('en')">EN</h6>
                    </div>
                </div>
            </template>
        </Sidebar>
        <Button icon="pi pi-bars" @click="visible = true" class="menu-button"
            :class="props.onHomePage ? 'fill-light' : 'fill-dark '" />
    </div>
</template>

<script setup>
import Sidebar from 'primevue/sidebar';
import Button from 'primevue/button';
import { ref } from "vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();

const props = defineProps({
    onHomePage: {
        type: Boolean,
        default: false
    }
})

const setLang = (newLang) => {
    locale.value = newLang;
    localStorage.setItem("lang", newLang);
};

const savedLang = localStorage.getItem("lang");
if (savedLang) {
    locale.value = savedLang;
}


function topPage() {
    window.scrollTo({
        top: 0
    });
}

const visible = ref(false);
</script>

<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.sidebar-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem;
    /* background-color: #282828; */
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 1rem;
}

.branding {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.logo {
    height: 50px;
    filter: invert(90%);
}

.close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #282828;
}

.menu-content {
    overflow-y: auto;
    padding-top: 1rem;
}

.menu-list,
.submenu-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-section {
    display: flex;
    align-items: end;
}

.menu-section a {
    padding: 1rem;
    cursor: pointer;
    text-decoration: none;
    color: #282828;
}

.menu-section a:hover {
    font-weight: 500;
    transition: ease-in 200ms;
}


.menu-section a.router-link-exact-active {
    font-weight: 500;
}

.section-title {
    font-weight: 500;
    color: #666;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    color: #444;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;
}

.menu-item:hover {
    background-color: #f0f0f0;
}

.has-submenu .pi-chevron-down {
    margin-left: auto;
}

.footer {
    margin-top: auto;
    padding: 1rem;

}


.menu-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.header-icons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
}

.header-icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    filter: invert(90%);
}

.lang {
    cursor: pointer;
    font-size: 16px;
    text-transform: uppercase;
    -webkit-user-select: none;
    /* Safari */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE10+/Edge */
    user-select: none;
    /* Standard */
}
</style>
